import React, { useState, useEffect, useRef } from 'react';
import img1 from "../assets/1s.png";
import img2 from "../assets/2s.png";
import img3 from "../assets/3s.png";

const images = [img1, img2, img3];

const ElevatorSlider = () => {
  const [current, setCurrent] = useState(0);
  const length = images.length;
  const sliderRef = useRef(null);

  useEffect(() => {
    const timer = setInterval(() => {
      nextSlide();
    }, 3000);
    return () => clearInterval(timer);
  }, [current]);

  const prevSlide = () => setCurrent(current === 0 ? length - 1 : current - 1);
  const nextSlide = () => setCurrent(current === length - 1 ? 0 : current + 1);

  return (
    <div
      className="relative h-80 sm:h-96 md:h-[520px] lg:h-[620px] overflow-hidden rounded-md"
      style={{ width: '100vw', marginLeft: 'calc(50% - 50vw)' }}
    >
      <div
        ref={sliderRef}
        className="flex transition-transform duration-700 ease-in-out h-full"
        style={{ transform: `translateX(-${current * 100}%)` }}
      >
        {images.map((img, index) => (
          <div key={index} className="min-w-full h-full">
            <img
              src={img}
              alt={`Slide ${index}`}
              className="w-full h-full object-cover rounded-md"
            />
          </div>
        ))}
      </div>

      {/* Prev / Next Buttons */}
      <button
        onClick={prevSlide}
        className="absolute top-1/2 left-4 transform -translate-y-1/2 z-20 bg-white bg-opacity-60 hover:bg-opacity-90 rounded-full p-2 text-2xl sm:text-3xl md:text-4xl font-bold"
      >
        ‹
      </button>
      <button
        onClick={nextSlide}
        className="absolute top-1/2 right-4 transform -translate-y-1/2 z-20 bg-white bg-opacity-60 hover:bg-opacity-90 rounded-full p-2 text-2xl sm:text-3xl md:text-4xl font-bold"
      >
        ›
      </button>

      {/* Dots */}
      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2 z-20">
        {images.map((_, idx) => (
          <span
            key={idx}
            onClick={() => setCurrent(idx)}
            className={`w-3 h-3 rounded-full cursor-pointer transition-colors ${current === idx ? "bg-green-600" : "bg-white bg-opacity-50"}`}
          />
        ))}
      </div>
    </div>
  );
};

export default ElevatorSlider;
